// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import LayoutColumnsGrid, { columnCss } from 'components/helpers/LayoutColumnsGrid';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

export type LayoutThreeColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutThreeColumnShellProps = {
  left: JSX.Element;
  middle: JSX.Element;
  right: JSX.Element;
};

export const LayoutThreeColumnShell = ({
  left,
  middle,
  right,
}: LayoutThreeColumnShellProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const leftPlaceholder = left.props.rendering?.placeholders['nmdp-one-third-left'];
  const leftPlaceholderIsEmpty = leftPlaceholder?.length === 0;
  const middlePlaceholder = middle.props.rendering?.placeholders['nmdp-one-third-middle'];
  const middlePlaceholderIsEmpty = middlePlaceholder?.length === 0;
  const rightPlaceholder = right.props.rendering?.placeholders['nmdp-one-third-right'];
  const rightPlaceholderIsEmpty = rightPlaceholder?.length === 0;

  return (
    <LayoutColumnsGrid columns={3}>
      {(isEE || !leftPlaceholderIsEmpty) && <div className={columnCss}>{left}</div>}
      {(isEE || !middlePlaceholderIsEmpty) && <div className={columnCss}>{middle}</div>}
      {(isEE || !rightPlaceholderIsEmpty) && <div className={columnCss}>{right}</div>}
    </LayoutColumnsGrid>
  );
};

const LayoutThreeColumn = ({ rendering, fields }: LayoutThreeColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-three-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutThreeColumnShell
        left={<PlaceholderWrapper name="nmdp-one-third-left" rendering={rendering} />}
        middle={<PlaceholderWrapper name="nmdp-one-third-middle" rendering={rendering} />}
        right={<PlaceholderWrapper name="nmdp-one-third-right" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutThreeColumn;
